import * as i0 from '@angular/core';
import { Directive, Optional, Input, HostListener, EventEmitter, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
class DotCheckboxDirective {
  checkboxes;
  data;
  host;
  constructor(checkboxes, elementRef) {
    this.checkboxes = checkboxes;
    this.host = elementRef.nativeElement;
  }
  onClick() {
    if (this.checkboxes) {
      this.checkboxes.change(this);
    }
  }
  static ɵfac = function DotCheckboxDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotCheckboxDirective)(i0.ɵɵdirectiveInject(DotCheckboxesDirective, 8), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotCheckboxDirective,
    selectors: [["", "dotCheckbox", ""]],
    hostBindings: function DotCheckboxDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("change", function DotCheckboxDirective_change_HostBindingHandler() {
          return ctx.onClick();
        });
      }
    },
    inputs: {
      data: "data"
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotCheckboxDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[dotCheckbox]'
    }]
  }], () => [{
    type: DotCheckboxesDirective,
    decorators: [{
      type: Optional
    }]
  }, {
    type: i0.ElementRef
  }], {
    data: [{
      type: Input
    }],
    onClick: [{
      type: HostListener,
      args: ['change']
    }]
  });
})();
class DotCheckboxesDirective {
  checkables;
  queryList;
  /**
   * Checked One box only
   */
  checks$ = new EventEmitter();
  /**
   * Checked One box only
   */
  single$ = new EventEmitter();
  /**
   * Checked Multiple boxes
   */
  multi$ = new EventEmitter();
  /**
   * Checked All boxes
   */
  all$ = new EventEmitter();
  /**
   * Checkbox Length
   */
  length;
  /**
   * Checked Data
   */
  checked;
  #update() {
    const {
      checkables,
      queryList
    } = this;
    let length = 0;
    const checked = [];
    if (checkables) {
      let current = checkables.length;
      length += current;
      while (current-- > 0) {
        const checkable = checkables[current];
        if (checkable.checked) {
          checked[checked.length] = checkable.value;
        }
      }
    }
    if (queryList) {
      length += queryList.length;
      queryList.forEach((directive, index) => {
        if (directive.host.checked) {
          checked[checked.length] = directive.data;
        }
      });
    }
    this.length = length;
    this.checked = checked;
  }
  #signal() {
    const {
      checked
    } = this;
    const length = checked.length;
    this.checks$.next(length ? checked : false);
    this.single$.next(length === 1 ? checked : false);
    this.multi$.next(length > 1 ? checked : false);
    this.all$.next(this.length === length ? checked : false);
  }
  setQueryList(queryList) {
    this.queryList = queryList;
    this.#update();
  }
  change(directive) {
    const {
      checked
    } = this;
    const {
      host
    } = directive;
    if (host.checked) {
      checked[checked.length] = directive.data;
    } else {
      const index = checked.indexOf(directive.data);
      checked.splice(index, 1);
    }
    this.#signal();
  }
  checks() {
    const {
      checkables,
      queryList
    } = this;
    const checked = [];
    if (checkables) {
      const end = checkables.length;
      let current = -1;
      while (++current < end) {
        const checkable = checkables[current];
        checkable.checked = true;
        checkable.checked$.next(true);
        checked[checked.length] = checkable.value;
      }
    }
    if (queryList) {
      queryList.forEach(directive => {
        directive.host.checked = true;
        checked[checked.length] = directive.data;
      });
    }
    this.checked = checked;
    this.checks$.next(checked);
    this.single$.next(false);
    this.multi$.next(checked);
    this.all$.next(checked);
  }
  unchecks() {
    const {
      checkables,
      queryList
    } = this;
    if (checkables) {
      const end = checkables.length;
      let current = -1;
      while (++current < end) {
        const checkable = checkables[current];
        checkable.checked = false;
        checkable.checked$.next(false);
      }
    }
    if (queryList) {
      queryList.forEach(directive => {
        directive.host.checked = false;
      });
    }
    this.checked = [];
    this.checks$.next(false);
    this.single$.next(false);
    this.multi$.next(false);
    this.all$.next(false);
  }
  toggles(event) {
    const {
      checkables,
      queryList
    } = this;
    const checked = [];
    if (checkables) {
      const end = checkables.length;
      let current = -1;
      while (++current < end) {
        const checkable = checkables[current];
        const checked_ = !checkable.checked;
        checkable.checked = checked_;
        checkable.checked$.next(checked_);
        if (checked_) {
          checked[checked.length] = checkable.value;
        }
      }
    }
    if (queryList) {
      queryList.forEach(directive => {
        const checked_ = !directive.host.checked;
        directive.host.checked = checked_;
        if (checked_) {
          checked[checked.length] = directive.data;
        }
      });
    }
    this.checked = checked;
    this.#signal();
  }
  static ɵfac = function DotCheckboxesDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotCheckboxesDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotCheckboxesDirective,
    selectors: [["", "dotCheckboxes", ""]],
    inputs: {
      checkables: "checkables",
      queryList: "queryList"
    },
    outputs: {
      checks$: "checks$",
      single$: "single$",
      multi$: "multi$",
      all$: "all$"
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotCheckboxesDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[dotCheckboxes]'
    }]
  }], null, {
    checkables: [{
      type: Input
    }],
    queryList: [{
      type: Input
    }],
    checks$: [{
      type: Output
    }],
    single$: [{
      type: Output
    }],
    multi$: [{
      type: Output
    }],
    all$: [{
      type: Output
    }]
  });
})();
class DotCheckboxesToggleDirective {
  checkboxes;
  _host;
  constructor(checkboxes, elementRef) {
    this.checkboxes = checkboxes;
    this._host = elementRef.nativeElement;
    checkboxes.all$.pipe(takeUntilDestroyed()).subscribe(flag => {
      this._host.checked = !!flag;
    });
  }
  /**
   * 개별 체크박스 체크 상태 변경에서 전체선택 체크박스 상태를 기준으로 선택, 선택 해제로 변경
   * - 231027 kdh
   * @param event
   */
  onClick(event) {
    const checked = this._host.checked;
    if (checked) {
      this.checkboxes.checks();
    } else {
      this.checkboxes.unchecks();
    }
    // this.checkboxes.toggles();
    event.stopPropagation();
    event.preventDefault();
    return false;
  }
  static ɵfac = function DotCheckboxesToggleDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotCheckboxesToggleDirective)(i0.ɵɵdirectiveInject(DotCheckboxesDirective), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotCheckboxesToggleDirective,
    selectors: [["", "dotCheckboxesToggle", ""]],
    hostBindings: function DotCheckboxesToggleDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("change", function DotCheckboxesToggleDirective_change_HostBindingHandler($event) {
          return ctx.onClick($event);
        });
      }
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotCheckboxesToggleDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[dotCheckboxesToggle]'
    }]
  }], () => [{
    type: DotCheckboxesDirective
  }, {
    type: i0.ElementRef
  }], {
    onClick: [{
      type: HostListener,
      args: ['change', ['$event']]
    }]
  });
})();
function checkableChecks(options) {
  let current = options?.length;
  while (current-- > 0) {
    const option = options[current];
    option.checked$.next(true);
    option.checked = true;
  }
  return options;
}

/**
 * Generated bundle index. Do not edit.
 */

export { DotCheckboxDirective, DotCheckboxesDirective, DotCheckboxesToggleDirective, checkableChecks };
